var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6107 9.55354L24.3145 0.547019C23.7642 0.204937 23.1214 0.00165258 22.4273 0.00165258L3.57954 0C2.88546 0 2.23763 0.203268 1.68896 0.545367L12.3962 9.54851C12.7614 9.81126 13.2504 9.81134 13.6107 9.55354Z",
    fill: "#46A9DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6816 10.8641C14.6684 10.8774 14.6568 10.8856 14.6436 10.8939C14.161 11.2541 13.5859 11.4359 13.0059 11.4359C12.4307 11.4359 11.8507 11.2574 11.3681 10.8939C11.3549 10.8856 11.3434 10.8724 11.3301 10.8641L0.504034 1.75989C0.186739 2.29366 0 2.91505 0 3.57938V15.5393C0 17.5158 1.60797 19.1188 3.57947 19.1188H22.4272C24.4037 19.1188 26.0067 17.5108 26.0067 15.5393V3.58446C26.0067 2.91683 25.8199 2.29379 25.5026 1.76166L14.6816 10.8641Z",
    fill: "#46A9DB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0576f5f66f70ae7ca02621abee75bd68.svg";
export { ForwardRef as ReactComponent };